<template>
  <footer class="app-footer">
    <div class="footer-content">
      <div class="footer-section">
        <p class="footer-copyright">{{ $t('footer.copyright') }}</p>
      </div>

      <div class="footer-section">
        <p class="footer-version">{{ $t('footer.version') }}: <span class="version-number">{{ appVersion }}</span></p>
      </div>

      <div class="footer-links">
        <router-link to="/legal" class="footer-link">
          {{ $t('footer.legal') }}
        </router-link>
        <span class="footer-separator">•</span>
        <router-link to="/terms" class="footer-link">
          {{ $t('footer.terms') }}
        </router-link>
        <span class="footer-separator">•</span>
        <router-link to="/privacy" class="footer-link">
          {{ $t('footer.privacy') }}
        </router-link>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { ref } from 'vue'

const appVersion = ref('1.0.0')
</script>

<style scoped>
.app-footer {
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  padding: 1.5rem 2rem;
  margin-top: 2rem;
  font-size: 0.875rem;
  color: #6c757d;
}

.footer-content {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
}

.footer-section {
  margin: 0;
  padding: 0;
}

.footer-copyright {
  margin: 0;
  text-align: center;
  color: #495057;
}

.footer-version {
  margin: 0;
  text-align: center;
  color: #6c757d;
}

.version-number {
  font-weight: 600;
  color: #495057;
  font-family: monospace;
}

.footer-links {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.footer-link {
  color: #0d6efd;
  text-decoration: none;
  transition: color 0.2s;
}

.footer-link:hover {
  color: #0b5ed7;
  text-decoration: underline;
}

.footer-separator {
  color: #dee2e6;
  margin: 0 0.25rem;
}

@media (max-width: 768px) {
  .app-footer {
    padding: 1rem 1.5rem;
  }

  .footer-content {
    gap: 0.75rem;
  }

  .footer-links {
    gap: 0.25rem;
    font-size: 0.8rem;
  }
}
</style>
